module.exports = __webpack_public_path__ + "static/media/bnty.20beb800.svg";